var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ComingSoonFeatureVote',{attrs:{"title":_vm.$t('broker.app.navigation.leagues'),"description":_vm.$t('broker.leagues.leaguesDescription'),"image-src":_vm.imageSrc,"feature-name":"COMING_FEATURE_LEAGUES"}})
}
var staticRenderFns = []

export { render, staticRenderFns }